export const USER_MANAGEMENT = 'user-management';
export const PRODUCT_MANAGEMENT = 'product-management';
export const OFFERING_MANAGEMENT = 'offering-management';
export const LOCATION_MANAGEMENT = 'location-management';
export const SALES_CHANNEL_MANAGEMENT = 'sales-channel-management';
export const ORDER_MANAGEMENT = 'order-management';
export const CAMPAIGN_MANAGEMENT = 'campaign-management';
export const LOGOUT = 'logout';
